import styled from 'styled-components';

export const Container = styled.div`
  padding: 1em 2rem;
  display: flex;
  gap: 2rem;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.background};
  min-height: 100vh;

  .page-title {
    display: flex;
    justify-content: start;
  }

  .disabled {
    filter: grayscale(1);
    opacity: 0.5;
    cursor: not-allowed;
    button {
      :hover:disabled {
        color: #fff;
        background-color: ${({ theme }) => theme.colors.primary};
        border: 1px solid ${({ theme }) => theme.colors.primary};
      }
    }

    Input {
      &:hover:disabled {
        &::placeholder {
          font-size: 1.6rem;
        }
      }
    }
  }

  @media (max-width: 650px) {
    gap: 1rem;
  }

  @media (max-width: 300px) {
    padding: 1em 0.5rem;
  }
`;

export const Content = styled.div`
  display: flex;
  gap: 1rem;
  padding: 3rem;
  justify-content: center;

  .ContentItens {
    display: flex;
    gap: 1rem;
  }

  @media (max-width: 1000px) {
    padding: 0;
  }

  @media (max-width: 650px) {
    padding: 0;
    margin-top: 0.3rem;

    .ContentItens {
      display: flex;
      flex-direction: column;
      width: -webkit-fill-available;
      gap: 1rem;
    }
  }
`;

export const ColContent = styled.div`
  width: 100%;
  min-width: 40%;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  @media (max-width: 650px) {
    gap: 1rem;
  }
`;

export const SendEmail = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.background_white};
  box-shadow: 0px 3px 6px #00000029;
  border: 0.5px solid #ffffff;
  border-radius: 17px;
  opacity: 1;
  padding: 2rem;
  gap: 1rem;

  .txtSend {
    display: flex;
    color: ${({ theme }) => theme.colors.secondary};

    svg {
      width: 2rem;
      height: 2rem;
      fill: ${({ theme }) => theme.colors.primary};
      stroke: ${({ theme }) => theme.colors.primary};
    }

    p {
      font-weight: 300;
      margin: 0;
      font-size: 20px;
      margin-left: 1rem;
    }
  }

  .formSend {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .inputSend {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      input {
        width: 90%;
        height: 2rem;
        border: none;
        outline: none;
        font-size: 1.6rem;
      }
    }

    .btnSend {
      padding: 0 2.5rem 0 2rem;
    }
  }

  @media (max-width: 1010px) {
    .inputSend {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      padding-left: 0;

      input {
        width: 100%;
      }
    }

    .btnSend {
      width: 100%;
      padding: 0px;
      display: flex;
      justify-content: center;
    }
  }

  @media (max-width: 650px) {
    gap: 2rem;

    .inputSend {
      gap: 2rem;
    }
  }

  @media (max-width: 300px) {
    padding: 1rem;
  }
`;

export const CodRecovery = styled.div`
  display: flex;
  background: ${({ theme }) => theme.colors.background_white};
  box-shadow: 0px 3px 6px #00000029;
  border: 0.5px solid #ffffff;
  border-radius: 17px;
  opacity: 1;
  color: ${({ theme }) => theme.colors.secondary};
  padding: 2rem;

  .ContentInputs {
    width: 100%;
    gap: 1rem;
    display: flex;
    flex-direction: column;

    .DivTitle {
      display: flex;
      gap: 1rem;

      h1 {
        font-size: 2.5rem;
        font-weight: 700;
      }

      h2 {
        margin: 0;
        font-weight: 300;
      }

      p {
        color: ${({ theme }) => theme.colors.gray};
        font-size: 1.2rem;
        margin: 0 0.3rem;
        font-weight: 300;
      }
    }

    .inputsCod {
      display: flex;
      gap: 1rem;
      padding-left: 3rem;

      .inputs {
        width: 90%;
        display: flex;
        justify-content: center;
      }

      input[type='number']::-webkit-inner-spin-button {
        -webkit-appearance: none;
      }

      input[type='number'] {
        -moz-appearance: textfield;
        appearance: textfield;
      }

      input {
        width: 50px;
        height: 54px;
        border: 1px solid ${({ theme }) => theme.colors.secondary};
        border-radius: 10px;
        opacity: 1;
        color: ${({ theme }) => theme.colors.secondary};
        font-size: 2rem;
        text-align: center;
      }

      .BtnVerify {
        display: flex;
        align-items: flex-end;
        padding: 0 2.5rem 0 2rem;
      }
    }
  }

  @media (max-width: 1010px) {
    .ContentInputs .inputsCod {
      flex-direction: column;
      padding-left: 0;

      .inputs {
        width: 100%;
      }

      .BtnVerify {
        padding: 0px;
        display: flex;
        justify-content: center;
      }
    }
  }

  @media (max-width: 650px) {
    .ContentInputs {
      gap: 2rem;

      .inputsCod {
        gap: 2rem;
      }
    }
  }

  @media (max-width: 300px) {
    padding: 1rem;
  }
`;

export const ContainerNewPassword = styled.div`
  width: 32%;
  min-width: 32%;
  display: flex;
  align-items: center;

  @media (max-width: 650px) {
    width: 100%;
  }
`;

export const NewPassword = styled.div`
  height: 100%;
  background: ${({ theme }) => theme.colors.background_white};
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 16px;
  opacity: 1;

  .Title {
    padding: 2rem;
    display: grid;
    grid-template-columns: 1fr 15fr;
    color: ${({ theme }) => theme.colors.secondary};
    gap: 0.5rem;
    align-items: center;

    svg {
      fill: ${({ theme }) => theme.colors.secondary};
    }
  }

  h2 {
    margin: 0;
    font-size: 25px;
    font-weight: 300;
  }

  svg {
    margin-bottom: 0.01rem solid ${({ theme }) => theme.colors.text};
  }

  .InputPassword {
    display: grid;
    gap: 5rem;
    padding: 0 2rem 2rem 2rem;

    .css-1y2k77-MuiInputBase-root-MuiInput-root.Mui-disabled:before {
      border-bottom-style: solid;
    }

    input {
      width: 90%;
      padding: 2rem 0.2rem 1rem 0rem;
      height: 2rem;
      border: none;
      border-bottom: 0.01rem solid ${({ theme }) => theme.colors.text};
      font-size: 1.6rem;
      padding-top: 1.5rem;
      background-color: ${({ theme }) => theme.colors.background_white};
    }
  }

  .btnUpdatePassword {
    margin: auto;
  }

  @media (max-width: 650px) {
    width: 100%;
    min-height: 300px;
  }

  @media (max-width: 300px) {
    .Title {
      padding: 1rem;
    }
    .InputPassword {
      padding: 0 1rem 1rem 1rem;
    }
  }
`;
